import { Component, OnInit } from '@angular/core';
import { Constants } from 'src/app/utilities/Constants';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  headerMsg = Constants.TEST_SYS_MSG;

  constructor() { }

  ngOnInit() {
  }

}
